export default __webpack_public_path__ + "static/6-game-icon-cca58f13c3a9d5fbac2c037267e10eba.jpg";